import { ImputationMethod } from '@ebalance/proto/bffuser/v1/imputation_policy_model_pb'

/**
 * 需要側で選択できる補完方式 (spec §1 の 2 択)。
 * 表示順は design/balance/imputation-policy.html の DEMAND_METHODS と一致。
 */
export const DEMAND_METHODS: ImputationMethod[] = [
  ImputationMethod.PREV_TIME,
  ImputationMethod.SAME_WEEKDAY_RECENT,
]

/** 需要側のデフォルト方式 (spec AC-002: 直前コマ引用)。 */
export const DEFAULT_DEMAND_METHOD: ImputationMethod =
  ImputationMethod.PREV_TIME

/**
 * 発電側のデフォルトのフォールバック順 (spec AC-008:
 * ①計画値代入 → ②直前コマ引用)。
 */
export const DEFAULT_GENERATION_METHOD_ORDER: ImputationMethod[] = [
  ImputationMethod.PLAN_VALUE,
  ImputationMethod.PREV_TIME,
]

/**
 * update_mask に載せる path。backend の allowedPaths
 * (adapter/grpc/handler/imputationpolicy/converter.go) と一致させる。
 */
export const FIELD_PATHS = {
  demandMethod: 'demand_method',
  generationMethodOrder: 'generation_method_order',
} as const

/**
 * 方式名・説明文の i18n キー。文言の SoT は
 * design/balance/imputation-policy.html の METHODS 定義。
 */
export const METHOD_I18N_KEYS: Record<
  ImputationMethod,
  { name: string; description: string }
> = {
  [ImputationMethod.UNSPECIFIED]: { name: '', description: '' },
  [ImputationMethod.PREV_TIME]: {
    name: 'page:balanceImputationPolicy.methods.prevTime.name',
    description: 'page:balanceImputationPolicy.methods.prevTime.description',
  },
  [ImputationMethod.SAME_WEEKDAY_RECENT]: {
    name: 'page:balanceImputationPolicy.methods.sameWeekdayRecent.name',
    description:
      'page:balanceImputationPolicy.methods.sameWeekdayRecent.description',
  },
  [ImputationMethod.PLAN_VALUE]: {
    name: 'page:balanceImputationPolicy.methods.planValue.name',
    description: 'page:balanceImputationPolicy.methods.planValue.description',
  },
}
